import type { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';

import { ISmevMonitoringIndex } from 'APIPackage/SmevMonitoringModule/interfaces/ISmevMonitoringIndex';
import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import styles from './SmevMonitoringServiceCell.module.scss';
import { smevMonitoringGetChartsWithEndpoints } from '../actions/smevMonitoringActions';

export const SmevMonitoringServiceCell = ({ row }: ITableRenderCell<ISmevMonitoringIndex>) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const handleGetDetailCharts = (system: string, service: string) => () => {
    if (system && service) {
      dispatch(smevMonitoringGetChartsWithEndpoints(system, service));
    }
  };

  return (
    <div className={styles.TbodyClickable} onClick={handleGetDetailCharts(row.system, row.service)}>
      {row.service}
    </div>
  );
};
